import {isMobileByScreen} from 'core/helpers/screen';
import {useResize} from 'core/hooks/useResize';
import {useCallback, useEffect, useState} from 'react';

export const useIsMobileByScreen = () => {
    const [isMobile, setIsMobile] = useState(false);

    const handleWindowResize = useCallback(() => setIsMobile(isMobileByScreen()), []);

    useEffect(() => {
        setIsMobile(isMobileByScreen());
    }, []);

    useResize(handleWindowResize);

    return isMobile;
};
